import {User} from "@/interfaces/user";

export interface Document {
  id: number
  type: string
  name: string
  location: string
  creator: User
  createdAt: string
}

export class Document {
  constructor(data: Partial<Document>) {
    Object.assign(this, data);
  }
}

export enum DocumentType {
  DELIVERY_NOTES = 'delivery_notes',
  REPORTS = 'reports',
  PACKING_LIST = 'packing_list',
  DSA = 'dsa_customs_document',
  DAE = 'dae_customs_document',
  CMR = 'cmr_waybills',
}

export enum DocumentOrigin {
  ORDER = "order",
  RECEPTION = "reception",
}
